import TimelineReduxStoreProvider from 'crm-events-data/internal/redux/TimelineReduxStoreProvider';
import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
import { RouterMark } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { Route, Switch, Redirect } from 'react-router-dom';
import ProfileNotFound from '../crm_ui/profile/ProfileNotFound';
import RecordDataProvider from '../providers/RecordDataProvider';
import ContactListMembershipRouteAsync from '../routes/ContactListMembershipRouteAsync';
import ContactRecordEmailRouteAsync from '../routes/ContactRecordEmailRouteAsync';
import ContactWorkflowRouteAsync from '../routes/ContactWorkflowRouteAsync';
import DealLineItemEditorRouteAsync from '../routes/DealLineItemEditorRouteAsync';
import LinkedInSalesNavigatorRouteAsync from '../routes/LinkedInSalesNavigatorRouteAsync';
import QuoteRouteAsync from '../routes/QuoteRouteAsync';
import RecordRoute from '../routes/RecordRoute';
import getRouteObjectTypeOverride from '../utils/getRouteObjectTypeOverride';
import OldRecordRouteLogger from '../utils/OldRecordRouteLogger';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NON_RECORD_PAGE_ROUTES = ['/contact/email/:email', '/:objectType/:subjectId/sales-navigator', '/contact/:subjectId/list-memberships', '/contact/:subjectId/workflow-memberships', '/deal/:subjectId/line-items'];
const NON_RECORD_PAGE_ROUTES_TO_PARAMS = ['/:objectType/email/:email', '/:objectType/:subjectId/sales-navigator', '/:objectType/:subjectId/list-memberships', '/:objectType/:subjectId/workflow-memberships', '/:objectType/:subjectId/line-items'];
const GENERIC_RECORD_ROUTES = {
  EMAIL: '/record/0-1/email/:email',
  SALES_NAVIGATOR: '/record/:objectType/:subjectId/sales-navigator',
  LIST_MEMBERSHIPS_CONTACT: '/record/0-1/:subjectId/list-memberships',
  LIST_MEMBERSHIPS_GENERIC: '/record/:objectType/:subjectId/list-memberships',
  WORKFLOW_MEMBERSHIPS_CONTACT: '/record/0-1/:subjectId/workflow-memberships',
  WORKFLOW_MEMBERSHIPS_GENERIC: '/record/:objectType/:subjectId/workflow-memberships',
  LINE_ITEMS: '/record/0-3/:subjectId/line-items',
  RECORD_WITH_TAB: '/record/:objectType/:subjectId/view/:tabId',
  RECORD: '/record/:objectType/:subjectId'
};
const PROPERTIES_ROUTES = ['/:objectType/:subjectId/properties', '/record/:objectType/:subjectId/properties', '/record/:objectType/:subjectId/history/:propertyName?', '/:objectType/:subjectId/history/:propertyName?'];
const LEGACY_NON_RECORD_ROUTES = {
  EMAIL: '/contact/email/:email',
  QUOTE: '/quote/:quoteId',
  SALES_NAVIGATOR: '/:objectType/:subjectId/sales-navigator',
  LIST_MEMBERSHIPS: '/:objectType/:subjectId/list-memberships',
  LIST_MEMBERSHIPS_CONTACT: '/contact/:subjectId/list-memberships',
  WORKFLOW_MEMBERSHIPS: '/:objectType/:subjectId/workflow-memberships',
  WORKFLOW_MEMBERSHIPS_CONTACT: '/contact/:subjectId/workflow-memberships',
  LINE_ITEMS: '/deal/:subjectId/line-items',
  RECORD_WITH_TAB: '/:objectType/:subjectId/view/:tabId',
  RECORD: '/:objectType/:subjectId'
};
const LEGACY_NON_GENERIC_ROUTE_PATHS = ['/contact/:subjectId', '/contacts/:subjectId', '/company/:subjectId', '/companies/:subjectId', '/deal/:subjectId', '/deals/:subjectId', '/ticket/:subjectId', '/tickets/:subjectId'];
const LEGACY_REDIRECT_ROUTES = [...LEGACY_NON_GENERIC_ROUTE_PATHS, '/:objectType/:subjectId/view/:tabId'];
const LEGACY_ROUTE_PATTERNS = ['/:objectType/:subjectId/view/:tabId', '/:objectType/:subjectId'];
export default function Routes() {
  const nonRecordPageRedirects = /*#__PURE__*/_jsx(Route, {
    path: NON_RECORD_PAGE_ROUTES,
    children: /*#__PURE__*/_jsx(Route, {
      path: NON_RECORD_PAGE_ROUTES_TO_PARAMS // turns a hard-coded objectType into a param that we can access in the redirect through the match props
      ,
      render: ({
        location: {
          search
        },
        match: {
          params: {
            objectType
          },
          url
        }
      }) => /*#__PURE__*/_jsx(Redirect, {
        to: `${url}${search}`.replace(`/${objectType}/`, `/record/${ObjectTypesToIds[getRouteObjectTypeOverride(objectType)]}/`)
      })
    })
  });
  const genericNonRecordPageRoutes = [/*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.EMAIL,
    children: /*#__PURE__*/_jsx(ContactRecordEmailRouteAsync, {})
  }, "email-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.SALES_NAVIGATOR,
    render: ({
      match: {
        params: {
          objectType,
          subjectId
        }
      }
    }) => /*#__PURE__*/_jsx(LinkedInSalesNavigatorRouteAsync, {
      objectType: getRouteObjectTypeOverride(objectType),
      subjectId: subjectId
    })
  }, "sales-navigator-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.LIST_MEMBERSHIPS_CONTACT,
    children: /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: GENERIC_RECORD_ROUTES.LIST_MEMBERSHIPS_GENERIC,
      render: ({
        match: {
          params: {
            objectType,
            subjectId
          }
        }
      }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
        children: /*#__PURE__*/_jsx(RecordDataProvider, {
          objectType: getRouteObjectTypeOverride(objectType),
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(ContactListMembershipRouteAsync, {})
        })
      })
    })
  }, "list-memberships-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.WORKFLOW_MEMBERSHIPS_CONTACT,
    children: /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: GENERIC_RECORD_ROUTES.WORKFLOW_MEMBERSHIPS_GENERIC,
      render: ({
        match: {
          params: {
            objectType,
            subjectId
          }
        }
      }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
        children: /*#__PURE__*/_jsx(RecordDataProvider, {
          objectType: getRouteObjectTypeOverride(objectType),
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(ContactWorkflowRouteAsync, {})
        })
      })
    })
  }, "workflow-memberships-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.LINE_ITEMS,
    children: /*#__PURE__*/_jsx(DealLineItemEditorRouteAsync, {})
  }, "line-items-route")];
  const nonRecordPageRoutes = [/*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.EMAIL,
    children: /*#__PURE__*/_jsx(OldRecordRouteLogger, {
      type: "contact",
      children: /*#__PURE__*/_jsx(ContactRecordEmailRouteAsync, {})
    })
  }, "email-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.QUOTE,
    children: /*#__PURE__*/_jsx(QuoteRouteAsync, {})
  }, "quote-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: PROPERTIES_ROUTES,
    children: () => {
      // Refresh page on crm-record-properties-ui routes
      window.location.reload();
      return null;
    }
  }, "refresh-on-properties-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.SALES_NAVIGATOR,
    render: ({
      match: {
        params: {
          objectType,
          subjectId
        }
      }
    }) => /*#__PURE__*/_jsx(OldRecordRouteLogger, {
      type: objectType,
      children: /*#__PURE__*/_jsx(LinkedInSalesNavigatorRouteAsync, {
        objectType: getRouteObjectTypeOverride(objectType),
        subjectId: subjectId
      })
    })
  }, "sales-navigator-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.LIST_MEMBERSHIPS_CONTACT,
    children: /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: LEGACY_NON_RECORD_ROUTES.LIST_MEMBERSHIPS,
      render: ({
        match: {
          params: {
            objectType,
            subjectId
          }
        }
      }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
        children: /*#__PURE__*/_jsx(RecordDataProvider, {
          objectType: getRouteObjectTypeOverride(objectType),
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(OldRecordRouteLogger, {
            type: objectType,
            children: /*#__PURE__*/_jsx(ContactListMembershipRouteAsync, {})
          })
        })
      })
    })
  }, "list-memberships-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.WORKFLOW_MEMBERSHIPS_CONTACT,
    children: /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: LEGACY_NON_RECORD_ROUTES.WORKFLOW_MEMBERSHIPS,
      render: ({
        match: {
          params: {
            objectType,
            subjectId
          }
        }
      }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
        children: /*#__PURE__*/_jsx(RecordDataProvider, {
          objectType: getRouteObjectTypeOverride(objectType),
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(OldRecordRouteLogger, {
            type: objectType,
            children: /*#__PURE__*/_jsx(ContactWorkflowRouteAsync, {})
          })
        })
      })
    })
  }, "workflow-memberships-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: LEGACY_NON_RECORD_ROUTES.LINE_ITEMS,
    children: /*#__PURE__*/_jsx(DealLineItemEditorRouteAsync, {})
  }, "line-items-route")];
  const legacyNonGenericRedirects = /*#__PURE__*/_jsx(Route, {
    path: LEGACY_REDIRECT_ROUTES,
    children: /*#__PURE__*/_jsx(Route, {
      path: LEGACY_ROUTE_PATTERNS,
      render: ({
        location: {
          search
        },
        match: {
          params: {
            objectType
          },
          url
        }
      }) => /*#__PURE__*/_jsx(Redirect, {
        to: `${url}${search}`.replace(`/${objectType}/`, `/record/${ObjectTypesToIds[getRouteObjectTypeOverride(objectType)]}/`)
      })
    })
  });
  const legacyNonGenericRoutes = [/*#__PURE__*/_jsx(Route, {
    exact: true,
    path: [LEGACY_NON_RECORD_ROUTES.RECORD_WITH_TAB],
    render: ({
      match: {
        params: {
          objectType,
          subjectId
        }
      }
    }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
      children: /*#__PURE__*/_jsx(RecordDataProvider, {
        objectType: getRouteObjectTypeOverride(objectType),
        subjectId: subjectId,
        children: /*#__PURE__*/_jsx(OldRecordRouteLogger, {
          type: objectType,
          children: /*#__PURE__*/_jsx(RecordRoute, {
            objectType: getRouteObjectTypeOverride(objectType)
          })
        })
      })
    })
  }, "legacy-middle-pane-tab-route"), /*#__PURE__*/_jsx(Route, {
    path: LEGACY_NON_GENERIC_ROUTE_PATHS,
    children: /*#__PURE__*/_jsx(Route, {
      path: LEGACY_NON_RECORD_ROUTES.RECORD,
      render: ({
        match: {
          params: {
            objectType,
            subjectId
          }
        }
      }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
        children: /*#__PURE__*/_jsx(RecordDataProvider, {
          objectType: getRouteObjectTypeOverride(objectType),
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(OldRecordRouteLogger, {
            type: objectType,
            children: /*#__PURE__*/_jsx(RecordRoute, {
              objectType: getRouteObjectTypeOverride(objectType)
            })
          })
        })
      })
    })
  }, "legacy-non-generic-record-route")];
  const genericRoutes = [/*#__PURE__*/_jsx(Route, {
    exact: true,
    path: [GENERIC_RECORD_ROUTES.RECORD_WITH_TAB],
    render: ({
      match: {
        params: {
          objectType,
          subjectId
        }
      }
    }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
      children: /*#__PURE__*/_jsx(RecordDataProvider, {
        objectType: getRouteObjectTypeOverride(objectType),
        subjectId: subjectId,
        children: /*#__PURE__*/_jsx(RecordRoute, {
          objectType: getRouteObjectTypeOverride(objectType)
        })
      })
    })
  }, "generic-middle-pane-tab-route"), /*#__PURE__*/_jsx(Route, {
    exact: true,
    path: GENERIC_RECORD_ROUTES.RECORD,
    render: ({
      match: {
        params: {
          objectType,
          subjectId
        }
      }
    }) => /*#__PURE__*/_jsx(TimelineReduxStoreProvider, {
      children: /*#__PURE__*/_jsx(RecordDataProvider, {
        objectType: getRouteObjectTypeOverride(objectType),
        subjectId: subjectId,
        children: /*#__PURE__*/_jsx(RecordRoute, {
          objectType: getRouteObjectTypeOverride(objectType)
        })
      })
    })
  }, "generic-record-route")];
  useMarkOnMount(RouterMark);
  return /*#__PURE__*/_jsxs(Switch, {
    children: [nonRecordPageRedirects, nonRecordPageRoutes, genericNonRecordPageRoutes, legacyNonGenericRedirects, legacyNonGenericRoutes, genericRoutes, /*#__PURE__*/_jsx(Route, {
      render: () => /*#__PURE__*/_jsx(ProfileNotFound, {})
    })]
  });
}